<template>
    <v-card>
        <v-toolbar color="grey lighten-3">
          <v-toolbar-title>{{title}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line></v-text-field>
        </v-toolbar>
        <v-layout row>
            <v-flex xs5>
                <v-subheader>
                  <v-checkbox color="green" v-model="unAssignedAllCheck"></v-checkbox>
                  <span>Un Assigned</span>
                </v-subheader>
                <v-divider></v-divider>
                <v-list :style="listInlineStyle">
                    <template v-for="item in unassignedItemsFiltered">
                        <v-list-tile :key="item.displayText">
                            <v-list-tile-action>
                                <v-checkbox color="green" v-model="item.selected"></v-checkbox>
                            </v-list-tile-action>
                            <v-list-tile-content @click="item.selected = !item.selected">
                                {{item.displayText}}
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                </v-list>
            </v-flex>
            <v-flex xs2 style="padding:0px;">
                <v-spacer style="height:50px;"></v-spacer>
                <v-btn outline fab small color="green" @click="assignItemClick">
                    <font-awesome-icon icon="angle-right"/>
                </v-btn>
                <v-btn outline fab small color="green" @click="unAssignItemClick">
                    <font-awesome-icon icon="angle-left"/>
                </v-btn>
            </v-flex>
            <v-flex xs5>
                <v-subheader>
                  <v-checkbox color="green" v-model="assignedAllCheck"></v-checkbox>
                  <span>Assigned</span>
                </v-subheader>
                <v-divider></v-divider>
                <v-list :style="listInlineStyle">
                    <template v-for="item in assignedItemsFiltered">
                        <v-list-tile :key="item.displayText">
                            <v-list-tile-action>
                                <v-checkbox color="green" v-model="item.selected"></v-checkbox>
                            </v-list-tile-action>
                            <v-list-tile-content @click="item.selected = !item.selected">
                                {{item.displayText}}
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                </v-list>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
export default {
  name: 'assignedInput',
  props: {
    title: String,
    listHeight: Number,
    unassignedItems: Array,
    assignedItems: Array,
  },
  computed: {
    listInlineStyle() {
      return `height: ${this.listHeight}px; overflow-y:auto;`;
    },
  },
  created() {
    const that = this;
    if (that.unassignedItems && that.unassignedItems.length > 0) {
      that.unassignedItems.forEach((o) => {
        that.unassignedItemsLocal.push(o);
      });
      that.unassignedItemsFiltered = that.unassignedItemsLocal;
    }
    if (that.assignedItems && that.assignedItems.length > 0) {
      that.assignedItems.forEach((o) => {
        that.assignedItemsLocal.push(o);
      });
      that.assignedItemsFiltered = that.assignedItemsLocal;
    }
  },
  data() {
    return {
      search: '',
      unAssignedAllCheck: false,
      assignedAllCheck: false,
      unassignedItemsLocal: [],
      assignedItemsLocal: [],
      unassignedItemsFiltered: [],
      assignedItemsFiltered: [],
    };
  },
  watch: {
    search(val) {
      this.filter(val);
    },
    unAssignedAllCheck(val) {
      // eslint-disable-next-line
      this.unassignedItemsFiltered.forEach((x) => { x.selected = val; });
    },
    assignedAllCheck(val) {
      // eslint-disable-next-line
      this.assignedItemsFiltered.forEach((x) => { x.selected = val; });
    },
  },
  methods: {
    filter(val) {
      if (val && val.length > 0) {
        this.unassignedItemsFiltered = this.unassignedItemsLocal.filter(x => x.displayText.toLowerCase().includes(val.toLowerCase()));
        this.assignedItemsFiltered = this.assignedItemsLocal.filter(x => x.displayText.toLowerCase().includes(val.toLowerCase()));
      } else {
        this.unassignedItemsFiltered = this.unassignedItemsLocal;
        this.assignedItemsFiltered = this.assignedItemsLocal;
      }
    },
    assignItemClick() {
      const that = this;
      const indices = [];
      that.unassignedItemsLocal.forEach((elem, index) => {
        if (elem.selected) {
          indices.push(index);
          // eslint-disable-next-line
          elem.selected = false;
          that.assignedItemsLocal.push(elem);
        }
      });
      for (let i = indices.length -1; i >= 0; i-=1) {
        that.unassignedItemsLocal.splice(indices[i], 1);
      }
      that.filter(that.search);
      that.unAssignedAllCheck = false;
      that.assignedAllCheck = false;
    },
    unAssignItemClick() {
      const that = this;
      const indices = [];
      that.assignedItemsLocal.forEach((elem, index) => {
        if (elem.selected) {
          indices.push(index);
          // eslint-disable-next-line
          elem.selected = false;
          that.unassignedItemsLocal.push(elem);
        }
      });
      for (let i = indices.length -1; i >= 0; i-=1) {
        that.assignedItemsLocal.splice(indices[i], 1);
      }
      that.filter(that.search);
      that.unAssignedAllCheck = false;
      that.assignedAllCheck = false;
    },
  },
};
</script>

<style scoped>

</style>
